import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/layout/header";
import { Footer } from "@/components/layout/footer";
import { ContactSection } from "@/components/sections/contact-section";
import { useLanguage } from "@/hooks/use-language";

const ContactPage = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-[#030014] min-h-screen overflow-x-hidden">
      <Header />
      <main className="pt-24">
        <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-16">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-white/60 hover:text-[#FF2E63] transition-colors"
              data-testid="back-home-btn"
            >
              <ArrowLeft className="w-5 h-5" />
              {t("nav.backToHome")}
            </Link>
          </motion.div>
        </div>
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
